import React from 'react';

import './footer.scss';
import { SAIPA } from '../../assets';
import Terms from '../../assets/pdfs/Website_TC.pdf';
import Privacy from '../../assets/pdfs/Website Privacy Policy.pdf';
import PrivacyNote from '../../assets/pdfs/Prispek Privacy Note.pdf';
import { Theme } from '../../config';
import { FooterContacts, FooterLinks, FooterLogos } from '..';

interface FooterProps {
    about?: boolean;
}

export const Footer: React.FC<FooterProps> = React.memo(({ about }) => (
    <div id='footer' className='footer' style={{ background: Theme.grey }}>
        <div className='footer__container'>
            <FooterContacts />
            <FooterLinks />
        </div>
        <p className='footer__disclaimer'>
            You are welcome to download any guide that could assist you in making
            more informed decisions and be better prepared for those events. Please
            note that these guides do not constitute advice, legal or ortherwise, but
            should be used in conjunction with adivce received from your accountant,
            financial advisor and/or attorney following a proper analysis of your
            individual situation and needs.
        </p>
        <FooterLogos about={about} />
        <div className='footer__saipa'>
            <p className='footer__saipa__title'>
                Prisma Accountants is a member of:
            </p>
            <a
                href='https://www.saipa.co.za'
                target='_blank'
                rel='noopener noreferrer'
            >
                <img src={SAIPA} alt='SAIPA' className='footer__saipa__image' />
            </a>
        </div>
        <div className='footer__rights'>
            <p className='footer__rights__copyright'>
                &copy; Prispek Consulting {new Date().getFullYear()} | Developed by
                Vermelion
            </p>
            <div className='footer__rights__terms'>
                <a
                    href={PrivacyNote}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='footer__rights__terms__term'
                >
                    Privacy Note
                </a>
                <a
                    href={Privacy}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='footer__rights__terms__term'
                >
                    Privacy Policy
                </a>
                {/* <a
          href={Desclaimer}
          target='_blank'
          rel='noopener noreferrer'
          className='footer__rights__terms__term'
        >
          Disclaimers
        </a> */}
                <a
                    href={Terms}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='footer__rights__terms__term'
                >
                    Terms
                </a>
            </div>
        </div>
    </div>
));
